<template>
  <v-app>
    <v-toolbar flat>
      <v-btn text color="primary" v-on:click="print">Print</v-btn>
    </v-toolbar>
    <div id="content">
      <div class="page" v-for="i in groups.length" v-bind:key="i">
        <div class="page_content" v-for="j in groups[i - 1].length" v-bind:key="i + '_' + j">
          <template v-if="groups[i - 1][j - 1] !== null">
            <div class="page--header">{{groups[i - 1][j - 1].name}}</div>
            <barcode v-bind:value="groups[i - 1][j - 1].code" height="50px" />
          </template>
        </div>
      </div>
    </div>
  </v-app>
</template>
<script>
import VueBarcode from "vue-barcode";
export default {
  name: "print-labels",
  data: () => ({
    groups: []
  }),
  components: {
    barcode: VueBarcode
  },
  methods: {
    openPrintLabel(items) {
      this.groups = [];
      for (const item of items) {
        for (var i = 0; i < item.quality; i++) {
          if (this.groups.length == 0) {
            this.groups.push([]);
          }
          if (this.groups[this.groups.length - 1].length == 8 * 3) {
            this.groups.push([]);
          }
          this.groups[this.groups.length - 1].push({
            name: item.name,
            code: item.code
          });
        }
      }
      while (this.groups[this.groups.length - 1].length != 3 * 8) {
        this.groups[this.groups.length - 1].push(null);
      }
      setTimeout(() => {
        var all = document.querySelectorAll("svg.vue-barcode-element");
        for (var j = 0; j < all.length; j++) {
          all[j].setAttribute("width", "100%");
        }
      }, 10);
    },
    print() {
      var printer = window.open(
        "",
        "",
        "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
      );
      let stylesHtml = "";
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style')
      ]) {
        stylesHtml += node.outerHTML;
      }
      //var prtHtml = document.getElementById('content').innerHTML;
      var pages = document.querySelectorAll(".page");
      var content = "";
      for (var i = 0; i < pages.length; i++) {
        content += pages[i].outerHTML;
      }
      printer.document.write(`<!DOCTYPE html>
				<html>
					<head>
						${stylesHtml}
					</head>
					<body>
						${content}
					</body>
				</html>`);
      printer.document.close();
      printer.focus();
      printer.print();
      printer.close();
    }
  },
  mounted() {
    var all = document.querySelectorAll("svg.vue-barcode-element");
    for (var i = 0; i < all.length; i++) {
      all[i].setAttribute("width", "100%");
    }
    var items = localStorage.getItem("print-items");
    items = JSON.parse(items);
    this.openPrintLabel(items);
  }
};
</script>
<style scoped>
.page {
  width: 21cm;
  min-height: 29.7cm;
  margin: 1cm auto;
  background: white;
  border-top: 1px solid black;
  border-left: 1px solid black;
  box-sizing: border-box;
  display: grid;
  grid-template-rows: repeat(8, 37mm);
  grid-template-columns: repeat(3, 70mm);
}

.page_content {
  box-sizing: border-box;
  border-right: 1px solid black;
  border-bottom: 1px solid black;
}

.page--header {
  text-align: center;
}

@page {
  size: A4;
  margin: 0;
}

@media print {
  .page {
    margin: 0;
    border: initial;
    border-radius: initial;
    width: initial;
    min-height: initial;
    box-shadow: initial;
    background: initial;
    page-break-after: always;
  }
}
</style>